module.exports = __webpack_public_path__ + "static/media/angular.5c69e565.svg";